import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button, SectionHeader } from "@pentabd/ui";
import {
  InputDateControllerRow,
  InputTextRow,
  MultiFileRow,
} from "@components";
import { IconPlus, IconTrash03 } from "@pentabd/icons";

import { FORM_FIELDS } from "@constants/form";

const FINAL_RECEIVING = FORM_FIELDS.PROCUREMENT_DETAILS.FINAL_RECEIVING;

export default function Documents() {
  const { t } = useTranslation();
  const { control, register, setValue } = useFormContext();

  // const { append, fields, remove } = useFieldArray({
  //   control,
  //   name: "AddDocuments",
  // });
  return (
    <div className="pt-10">
      <SectionHeader
        title={t("PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.ADD_DOCUMENT")}
      />
      {/* {fields.map((field, index) => ( */}
      <div className="pt-10">
        {/* <InputTextRow
            label="PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.DOCUMENT_NAME"
            register={{
              ...register(
                `AddDocuments.${index}.${FINAL_RECEIVING.DOCUMENT_NAME}`,
              ),
            }}
          />

          <InputDateControllerRow
            label="PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.DOCUMENT_DATE"
            control={control}
            register={{
              ...register(
                `AddDocuments.${index}.${FINAL_RECEIVING.DOCUMENT_DATE}`,
              ),
            }}
            name={`AddDocuments.${index}.${FINAL_RECEIVING.DOCUMENT_DATE}`}
          /> */}

        <MultiFileRow
          control={control}
          name={FINAL_RECEIVING.UPLOAD}
          register={register}
          setValue={setValue}
          fileDetails={["documentName", "date", "remarks", "memorialNo"]}
        />
        {/* <div className="text-end col-12 col-lg-10">
            <Button
              type="danger"
              fill="outline"
              size="sm"
              onClick={() => remove(index)}
            >
              <IconTrash03 size="20" fill="danger" />
              {t("PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.BUTTONS.DELETE")}
            </Button>
          </div> */}
      </div>
      {/* ))} */}
      {/* <div className="pt-10">
        <Button
          type="light"
          fill="outline"
          size="sm"
          onClick={() =>
            append({
              [FINAL_RECEIVING.DOCUMENT_NAME]: "",
              [FINAL_RECEIVING.DOCUMENT_DATE]: "",
              [FINAL_RECEIVING.UPLOAD]: [],
            })
          }
        >
          <IconPlus size="20" />
          {t("PROCUREMENT_CREATE.SPEC_PREPARATION.FORM.BUTTONS.ADD_MORE")}
        </Button>
      </div> */}
    </div>
  );
}
